
export default {
  readFileContent (file) {
    var reader = new FileReader()
    reader.readAsText(file, 'UTF-8')
    return reader
  }
}



// WEBPACK FOOTER //
// ./src/services/reader-service.js